<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center"
        [ngClass]="!isRedirectedFromClient ? 'mb-3 mt-3 mx-3' : 'mb-3'">
        <span class="col-auto d-flex gap-3 align-items-center head-custom-span">
          <div>
            <h2 *ngIf="!isRedirectedFromClient" class="mb-0">Projects</h2>
            <h2 *ngIf="isRedirectedFromClient" class="mb-0">
              Archive Projects
            </h2>
          </div>
          <div
            class="lds-ring inline me-auto sm-loader"
            *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </div>
          <div
            *ngIf="!isRedirectedFromClient"
            class="prospects-panel d-flex justify-content-between ms-2 me-auto inside-custom-span">
            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-radiobutton
                [(ngModel)]="selectedOption"
                value="0"
                inputId="0"
                name="radio"
                (onClick)="getWorkflowOnChange('0')" />
              <span class="link">All</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-checkbox
                [(ngModel)]="selectedCheckboxFilters"
                inputId="1"
                value="1"
                (onChange)="getWorkflowOnChange('1')" />

              <!-- <p-radiobutton
                [(ngModel)]="selectedOption"
                inputId="1"
                value="1"
                name="radio"
                (onClick)="getWorkflowOnChange('1')" /> -->
              <span class="link">Pre Sale</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-checkbox
                [(ngModel)]="selectedCheckboxFilters"
                inputId="2"
                value="2"
                (onChange)="getWorkflowOnChange('2')" />

              <!-- <p-radiobutton
                [(ngModel)]="selectedOption"
                inputId="2"
                value="2"
                name="radio"
                (onClick)="getWorkflowOnChange('2')" /> -->

              <span class="link">Production</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-checkbox
                [(ngModel)]="selectedCheckboxFilters"
                inputId="5"
                value="5"
                (onChange)="getWorkflowOnChange('5')" />

              <!-- <p-radiobutton
                [(ngModel)]="selectedOption"
                inputId="5"
                value="5"
                name="radio"
                (onClick)="getWorkflowOnChange('5')" /> -->

              <span class="link">Marked Complete</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-checkbox
                [(ngModel)]="selectedCheckboxFilters"
                inputId="4"
                value="4"
                (onChange)="getWorkflowOnChange('4')" />

              <!-- <p-radiobutton
                [(ngModel)]="selectedOption"
                inputId="4"
                value="4"
                name="radio"
                (onClick)="getWorkflowOnChange('4')" /> -->

              <span class="link">Cancelled</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
              <p-radiobutton
                name="radio"
                [(ngModel)]="selectedOption"
                (click)="showCustomDialog()" />
              <span class="link" for="0">Custom</span>
            </label>

            <label class="ms-5 nav-link p-0 d-flex align-items-center gap-2">
              <span class="link" for="0">Bulk Archive</span>
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                (onChange)="bulkArchiveToogleChange()"
                [(ngModel)]="bulkArchive" />
            </label>

            <label
              class="nav-link p-0 d-flex align-items-center"
              *ngIf="
                bulkArchive === true && selectedWorkFlowListing.length > 0
              ">
              <a (click)="achiveSelectedProjects()" class="link pe-1"
                >Archive Selected Projects</a
              >
            </label>
          </div>
        </span>

        <div class="col-auto d-flex gap-2 align-items-center right-custom-span">
          <div
            class="prospects-panel d-flex justify-content-between ms-2 me-auto">
            <div
              *ngIf="isRedirectedFromClient"
              class="prospects-panel d-flex justify-content-between ms-2 me-auto">
              <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
                <p-radiobutton
                  [(ngModel)]="selectedOption"
                  id="6"
                  value="6"
                  name="radio"
                  (onClick)="getWorkflowOnChange('6')" />
                <span class="link">Complete</span>
              </label>

              <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
                <p-radiobutton
                  [(ngModel)]="selectedOption"
                  id="10"
                  value="10"
                  name="radio"
                  (onClick)="getWorkflowOnChange('10')" />
                <span class="link">Cancelled</span>
              </label>

              <label class="ms-2 nav-link p-0 d-flex align-items-center gap-2">
                <p-radiobutton
                  [(ngModel)]="selectedOption"
                  id="11"
                  name="radio"
                  value="11"
                  (onClick)="getWorkflowOnChange('11')" />
                <span class="link">All</span>
              </label>
              <div *ngIf="searchPlaceholder !== 'Search'" class="ms-2">
                <span class="text-primary font-weight-bold">500</span>
                <span> Results for </span>
                <span class="text-primary">
                  <!-- <span>"</span> -->
                  <span></span>
                  <!-- <span>"</span> -->
                </span>
              </div>
            </div>
            <div *ngIf="searchPlaceholder !== 'Search'" class="ms-2">
              <span class="text-primary font-weight-bold">500</span>
              <span> Results for </span>
              <span class="text-primary">
                <!-- <span>"</span> -->
                <span></span>
                <!-- <span>"</span> -->
              </span>
            </div>
          </div>

          <div class="orders-panel col-auto d-flex justify-content-between">
            <div
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center"
              *ngIf="isAdmin">
              <a class="link" (click)="getNotificationSettings()"
                ><i class="pi pi-bell"></i> Notification Settings</a
              >
            </div>
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <p-button
                label="Remove Custom Sorting"
                (click)="clearManualSorting()"
                class="fullwdth secondary-btn" />
            </div>
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="redirectToDeliveryStatusAndException()"
                ><i class="pi pi-file"></i> Exception Logs</a
              >
            </div>
            <!-- <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center" *ngIf="!customerId">
              <a class="link" *ngIf="!listView" (click)="showListView(true)">List View</a>
            </div> -->
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="showOrHideUploadWorkflow()"
                ><i class="pi pi-file-import"></i> Import Excel</a
              >
            </div>
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <i class="icon-Export-excel me-2"></i>
              <a class="link" (click)="exportExcelForFilterData()"
                ><i class="pi pi-cloud-download"></i> Export excel</a
              >
            </div>
            <div
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center"
              *ngIf="!customerId">
              <a class="link" (click)="openWorkflowModal()"
                ><i class="pi pi-file-plus"></i> New Project Seq</a
              >
            </div>
          </div>
          <span
            class="cross-border ml-2"
            *ngIf="isModal"
            (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 242px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="workflowList"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="defaultTake"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          selectionMode="multiple"
          sortMode="multiple"
          [lazy]="true"
          [totalRecords]="totalRecords"
          (onLazyLoad)="getAllWorkflows($event)"
          [(selection)]="selectedWorkFlowListing"
          [globalFilterFields]="[
            'workflowId',
            'salesOrderIdD365',
            'workflowStatus',
          ]"
          [reorderableColumns]="true"
          (onRowReorder)="updateProjectWorkflowSorting($event)"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th *ngIf="bulkArchive === true"></th>
              <th></th>
              <th class="status d-flex gap-2" pSortableColumn="isFlag">
                <span class="pi pi-flag"></span>
                <p-sortIcon field="isFlag"></p-sortIcon>
              </th>
              <th
                style="width: 3rem"
                class="number"
                pSortableColumn="workflowId">
                Project <p-sortIcon field="workflowId"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="customerName">
                Client
                <p-sortIcon field="customerName"></p-sortIcon>
              </th>
              <th [class.trimmedbychar]="descriptionCharacterCond">Job Name</th>
              <th class="bEmail">POC</th>
              <th class="bEmail header" pSortableColumn="inHandDate">
                IHD
                <p-sortIcon field="inHandDate"></p-sortIcon>
              </th>
              <th class="status">Order</th>
              <th class="status" pSortableColumn="brandingConsultant">
                BC
                <p-sortIcon field="brandingConsultant"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="coOwner">
                Owner
                <p-sortIcon field="coOwner"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="workflowStatus">
                Project Status
                <p-sortIcon field="workflowStatus"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="lastDate">
                Modified
                <p-sortIcon field="lastDate"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="phaseStatusId">
                Phase
                <p-sortIcon field="phaseStatusId"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th *ngIf="bulkArchive === true"></th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="workflowId"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="buyerName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-center">
                  <jni-date-filter
                    [dataList]="workflowItems"
                    [filterMode]="filterMode"
                    [columnName]="'inHandDate'"
                    (emitCancelFilter)="onFilterPickerInput($event, 'clear')"
                    (emitApplyFilter)="onFilterPickerInput($event)">
                  </jni-date-filter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrderIdD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="brandingConsultant"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="coowner"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="workflowStatus"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-workflowItems
            let-rowIndex="rowIndex">
            <tr
              [pReorderableRow]="rowIndex"
              class="p-selectable-row"
              [pSelectableRow]="workflowItems"
              [pSelectableRowIndex]="rowIndex">
              <td *ngIf="bulkArchive === true">
                <p-tableCheckbox
                  class=""
                  [value]="workflowItems"
                  [pSelectableRow]="workflowItems"></p-tableCheckbox>
              </td>
              <td>
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td (click)="updateProjectWorkflowFlag($event, workflowItems)">
                <div *ngIf="!workflowItems.isFlag">
                  <span class="pi pi-flag"></span>
                </div>
                <div *ngIf="workflowItems.isFlag">
                  <span class="pi pi-flag-fill"></span>
                </div>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    openWorkflowSummaryModal(
                      workflowItems?.salesOrderIdD365,
                      workflowItems?.workflowId
                    )
                  "
                  >{{ getPaddedWorkflowId(workflowItems.workflowId) }}</a
                >
              </td>
              <td>{{ workflowItems.customerName }}</td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedbychar': descriptionCharacterCond,
                }"
                class="blur-bar task-title-cell">
                <div
                  class="blurshade d-flex justify-content-between align-items-center"
                  [pTooltip]="workflowItems.jobName"
                  tooltipPosition="top">
                  <span class="task-title-multiline">
                    {{ descriptionCharacterCount(workflowItems.jobName) }}
                    {{ workflowItems?.jobName }}
                  </span>
                </div>
              </td>
              <td>
                <a
                  class="link"
                  *ngIf="workflowItems?.buyerEmail !== ''"
                  [href]="'mailto:' + workflowItems?.buyerEmail"
                  >{{ workflowItems.buyerName }}</a
                >
                <a class="link" *ngIf="workflowItems?.buyerEmail === ''">
                  {{ workflowItems.buyerName }}
                </a>
              </td>
              <td class="d-flex flex-column text-center">
                <div
                  *ngIf="workflowItems.isArchived"
                  class="unarchive-div p-1"
                  style="display: inline-block">
                  <i
                    (click)="archiveEvent(workflowItems, false)"
                    class="pi pi-arrow-circle-up"></i>
                </div>
                <p-datePicker
                  *ngIf="
                    workflowItems.salesOrderIdD365 &&
                      workflowItems.salesOrderIdD365 !== '';
                    else elseBlock
                  "
                  [(ngModel)]="workflowItems.inHandDate"
                  [showButtonBar]="false"
                  [inputStyle]="{ height: '30px' }"
                  [style]="{ width: '100%' }"
                  [appendTo]="'body'"
                  dateFormat="mm-dd-yy"
                  (onSelect)="updateProjectWorkflowIHD($event, workflowItems)"
                  [minDate]="inHandDateCurrentdate">
                  <ng-template
                    pTemplate="footer"
                    *ngIf="!workflowItems.isArchived">
                    <span
                      class="link"
                      (click)="archiveEvent(workflowItems, true)"
                      >Mark as archived</span
                    >
                  </ng-template>
                </p-datePicker>
                <ng-template #elseBlock>
                  <div class="d-flex justify-content-center p-2 m-1">
                    <i
                      class="pi pi-folder-open"
                      (click)="archiveEvent(workflowItems, true)"></i>
                  </div>
                </ng-template>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    openSalesOrderModal(workflowItems?.salesOrderIdD365)
                  ">
                  {{ workflowItems.salesOrderIdD365 }}</a
                >
              </td>
              <td>{{ workflowItems.brandingConsultant }}</td>
              <td>{{ workflowItems.coOwner }}</td>
              <td
                [ngClass]="
                  getStatusClass(
                    workflowItems.colorStatus,
                    workflowItems.hasExceptions,
                    workflowItems.workflowStatusId
                  )
                ">
                <a
                  class="preview"
                  (click)="getTrackingLineItems($event, workflowItems)"
                  >{{ workflowItems.workflowStatus }}</a
                >
              </td>
              <td>{{ workflowItems.lastDate | date: "MM-dd-yyyy" }}</td>
              <td>
                {{ getPhaseStatus(workflowItems.phaseStatusId) }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No record found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="showWorkflowSummaryDialog"
  [displayModal]="showWorkflowSummaryDialog"
  (closeEvent)="closeWorkflowSummaryModal()">
  <div class="panelBody">
    <jni-production-workflow-summary
      [salesOrderId]="salesOrderId"
      [workflowId]="workflowId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (hasUnsavedChangesEvent)="onInputChanges($event)"
      (closeModalEvent)="closeWorkflowSummaryModal()">
    </jni-production-workflow-summary>
  </div>
</jni-modal-stacker>

<p-dialog
  header="New Project"
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [(visible)]="showWorkflowDialog"
  [style]="{
    width: '300px',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mb-2">
      <div>
        <div class="form-group has-float-label">
          <label class="form-label">Client Account</label>
          <input
            pInputText
            #mydropClient
            jniAutoCompleteBlocker
            type="text"
            id="customerAccount"
            name="customerAccount"
            class="form-control"
            [value]="customerIdD365"
            (input)="customerSearch$.next($any($event.target).value)"
            (keyup)="
              onCustomerSearchOpenToggle(clientPopover, $event, mydropClient)
            "
            (keydown.Tab)="getCustomerAccount($event, clientPopover)"
            (click)="onClienySearchList(clientPopover, $event, mydropClient)"
            (change)="changeClientAccount($event)" />
        </div>
        <p-popover
          class="order-dropdown add dropDownPosition search-table-position"
          #clientPopover>
          <p-table
            #dt
            [value]="customerLists"
            styleClass="p-datatable-customers order-listing"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0">
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name</th>
                <th class="vaccount">Client Account</th>
                <th
                  class="street"
                  style="width: 100px"
                  pSortableColumn="street">
                  Street
                  <p-sortIcon field="street"></p-sortIcon>
                </th>
                <th class="city" pSortableColumn="city">
                  City
                  <p-sortIcon field="city"></p-sortIcon>
                </th>
                <th class="state" pSortableColumn="state">
                  State
                  <p-sortIcon field="state"></p-sortIcon>
                </th>
                <th class="state" pSortableColumn="billingAttentionD365">
                  Attention
                  <p-sortIcon field="billingAttentionD365"></p-sortIcon>
                </th>
                <th class="country">Last order date</th>
              </tr>

              <tr>
                <th></th>
                <th></th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="street"
                      id="street"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'street',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="city"
                      id="city"
                      style="max-width: 200px"
                      (input)="
                        dt.filter($any($event.target).value, 'city', 'contains')
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="state"
                      id="state"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'state',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>

                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="billingAttentionD365"
                      id="billingAttentionD365"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'billingAttentionD365',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>

                <th></th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-customerList
              let-rowIndex="rowIndex">
              <tr
                class="p-selectable-row mousepointer"
                (click)="onClientSelection(customerList, clientPopover)">
                <td class="name mousepointer">
                  {{ customerList.organizationNameD365 }}
                </td>
                <td class="vaccount mousepointer">
                  {{ customerList.clientAccount }}
                </td>
                <td style="width: 200px" class="sname mousepointer">
                  {{ customerList.street }}
                </td>
                <td class="city mousepointer">{{ customerList.city }}</td>
                <td style="width: 72px" class="state mousepointer">
                  {{ customerList.state }}
                </td>
                <td style="width: 72px" class="state mousepointer">
                  {{ customerList.billingAttentionD365 }}
                </td>
                <td style="width: 75px" class="country mousepointer">
                  {{ customerList.lastOrderDate | date: "yyyy-MM-dd" }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No client found.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-popover>
      </div>
    </div>
    <div class="form-group has-float-label mb-2 mt-2">
      <label class="form-label">Job Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [(ngModel)]="jobName" />
    </div>

    <div class="form-group has-float-label mb-2 mt-2">
      <div>
        <div class="form-group has-float-label">
          <label class="form-label">Buyer</label>
          <div
            style="text-align: right; margin-top: -15px"
            *ngIf="customerIdD365 !== ''">
            <a
              class="small-link no-decoration"
              (click)="addContactInformation()"
              >+Add</a
            >
          </div>
          <input
            pInputText
            #mydropBuyer
            jniAutoCompleteBlocker
            type="text"
            id="buyer"
            name="buyer"
            class="form-control"
            [value]="buyerName"
            (input)="buyerVendor$.next($any($event.target).value)"
            (keyup)="onBuyerSearchOpenToggle(buyerPopover, $event, mydropBuyer)"
            (keydown.Tab)="getBuyer($event, buyerPopover)"
            (click)="onContactList(buyerPopover, mydropBuyer, $event)" />
        </div>
        <p-popover
          class="order-dropdown add dropDownPosition search-table-position"
          #buyerPopover>
          <p-table
            #dtBuyer
            stripedRows
            [size]="'small'"
            [value]="buyerLists"
            styleClass="p-datatable-customers order-listing table-listing"
            [style]="{ width: '900px' }"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [resizableColumns]="true"
            [filterDelay]="0"
            [scrollable]="true"
            [scrollHeight]="'calc(50vh - 90px)'">
            <ng-template pTemplate="header">
              <tr class="table-head">
                <th class="name">Buyer</th>
                <th class="email">Email</th>
                <th class="client" pSortableColumn="client">
                  Client
                  <p-sortIcon field="Client"></p-sortIcon>
                </th>
                <th class="vaccount">Account</th>
                <th class="street">Street</th>
                <th class="city">City</th>
                <th class="state">State</th>
                <th class="lastOrderDate">Last order date</th>
              </tr>
              <tr>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="buyer"
                      id="buyer"
                      style="max-width: 200px"
                      (input)="
                        dtBuyer.filter(
                          $any($event.target).value,
                          'buyer',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="buyerEmail"
                      id="buyerEmail"
                      style="max-width: 200px"
                      (input)="
                        dtBuyer.filter(
                          $any($event.target).value,
                          'buyerEmail',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="organizationNameD365"
                      id="organizationNameD365"
                      style="max-width: 200px"
                      (input)="
                        dtBuyer.filter(
                          $any($event.target).value,
                          'organizationNameD365',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-buyerList let-rowIndex="rowIndex">
              <tr
                class="p-selectable-row mousepointer"
                (click)="onBuyerSelection(buyerList, buyerPopover)">
                <td class="buyer mousepointer">
                  {{ buyerList.buyer }}
                </td>
                <td class="email mousepointer">
                  {{ buyerList.buyerEmail }}
                </td>
                <td class="client mousepointer">
                  {{ buyerList.organizationNameD365 }}
                </td>
                <td class="vaccount mousepointer">
                  {{ buyerList.account }}
                </td>
                <td style="width: 200px" class="sname mousepointer">
                  {{ buyerList.street }}
                </td>
                <td class="city mousepointer">{{ buyerList.city }}</td>
                <td style="width: 72px" class="state mousepointer">
                  {{ buyerList.state }}
                </td>
                <td style="width: 75px" class="country mousepointer">
                  {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No buyer found.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-popover>
      </div>
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <!-- <button
        class="btn btn-primary"
        type="click"
        (click)="addNewProjectHeader()">
        Create New
      </button> -->
      <p-button label=" Create New" (click)="addNewProjectHeader()" />
    </div>
  </div>
</p-dialog>

<jni-notification-settings
  *ngIf="notificationSettings.length > 0"
  [viewSettingsModal]="viewSettingsModal"
  [notificationSettings]="notificationSettings"
  (closeUpdateSettingModalEvent)="showOrHideNotificationSettings()"
  [workflowId]="0"
  [isGlobal]="true"
  (refreshDataEvent)="getNotificationSettings()"
  (dailogHideEventSettings)="hideNotificationSettingDailog($event)">
</jni-notification-settings>

<p-dialog
  [(visible)]="showUploadWorkflow"
  [modal]="true"
  header="Import Excel"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  styleClass="order-dialog">
  <!-- <button
    type="button"
    class="btn btn-primary mb-4"
    (click)="getWorkFlowHeaderCreateExcelTemplate()">
    Download Template
  </button> -->
  <div class="mb-1 mt-1">
    <p-button
      label="Download Template"
      (click)="getWorkFlowHeaderCreateExcelTemplate()" />
  </div>
  <p-fileUpload
    #workflowFileUpload
    name="file"
    (uploadHandler)="onUpload($event)"
    (onClear)="clearUploadFile()"
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    [customUpload]="true"
    class="jni-fileupload-hide-files">
    <ng-template
      pTemplate="content"
      let-files
      let-chooseCallback="chooseCallback">
      <div
        class="po-attachment-drag-drop-container"
        (dragover)="onDragOver($event)"
        (drop)="onFileDrop($event)"
        (dragleave)="onDragLeave($event)"
        (dragenter)="onDragEnter($event)">
        <div
          class="po-attachment-drag-drop-area"
          [class.drag-over]="isDragOver">
          <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
          <div class="po-attachment-drag-drop-text">
            <p class="mb-2">Drag & Drop files here</p>
          </div>
        </div>
        <div
          *ngIf="files && files.length > 0"
          class="po-attachment-files-preview mt-2">
          <div
            *ngFor="let file of files"
            class="po-attachment-file-item d-flex align-items-center p-2 border rounded mb-1">
            <i class="pi pi-file text-primary me-2"></i>
            <div class="flex-grow-1">
              <div class="font-weight-bold small">{{ file.name }}</div>
              <div class="text-muted small">
                {{ formatFileSize(file.size) }}
              </div>
            </div>
            <p-button
              icon="pi pi-times"
              (click)="removeFile(file)"
              class="p-button-text p-button-sm">
            </p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <!-- <button
        type="button"
        (click)="showOrHideUploadWorkflow()"
        class="btn btn-secondary me-3">
        Cancel
      </button> -->

      <p-button label="Cancel" (click)="showOrHideUploadWorkflow()" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Custom Filter"
  [(visible)]="showCustomFilterDialog"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false">
  <div class="p-fluid p-dir-col">
    <div class="form-group has-float-label mb-2 mt-2">
      <label class="form-label">Column Name</label>
      <p-select
        [(ngModel)]="selectedColumnName"
        placeholder="Select Column"
        (change)="onColumnNameChange()"
        [filter]="true"
        [showClear]="true"
        [options]="columnsList"
        appendTo="body"
        optionLabel="label"
        optionValue="name">
      </p-select>
    </div>
    <div
      *ngIf="isRadioInput"
      class="prospects-panel d-flex justify-content-start me-auto">
      <label class="ms-2 p-0 d-flex align-items-center">
        <input
          id="checked"
          type="radio"
          class="me-1"
          name="flag"
          value="true"
          [(ngModel)]="customValue" />
        <span>Checked</span>
      </label>
      <label class="ms-3 p-0 d-flex align-items-center">
        <input
          id="unchecked"
          type="radio"
          class="me-1"
          name="flag"
          value="false"
          [(ngModel)]="customValue" />
        <span>UnChecked</span>
      </label>
    </div>

    <div class="form-group has-float-label mb-2 mt-2">
      <p-datePicker
        *ngIf="isDateInput"
        [(ngModel)]="customDate"
        [showButtonBar]="false"
        [inputStyle]="{ height: '30px' }"
        [style]="{ width: '100%' }"
        [appendTo]="'body'"
        dateFormat="mm-dd-yy">
      </p-datePicker>

      <p-select
        *ngIf="isPhaseList"
        [(ngModel)]="customValue"
        placeholder="Select phase"
        [filter]="true"
        [showClear]="true"
        [options]="phaseList"
        optionValue="id"
        optionLabel="status">
      </p-select>

      <p-select
        *ngIf="isStatusList"
        [(ngModel)]="customValue"
        placeholder="Select status"
        [filter]="true"
        [showClear]="true"
        [options]="workflowStatusList"
        optionLabel="status"
        optionValue="status">
      </p-select>
      <label *ngIf="!isRadioInput" class="form-label">Value</label>
      <input
        pInputText
        *ngIf="isTextInput"
        type="text"
        [(ngModel)]="customValue"
        class="form-control" />
    </div>
    <div class="d-flex justify-content-end pt-2 gap-2">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeCustomDialog()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="button"
        (click)="applyCustomFilter()">
        Apply
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeCustomDialog()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Apply" (click)="applyCustomFilter()" />
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Line Items"
  [(visible)]="linesPreview"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ height: '50vh', widht: '80vh' }">
  <div>
    <jni-workflow-line-items
      *ngIf="orderLines"
      [orderLines]="orderLines"
      [statusList]="workflowStatusList"
      [workflowId]="workflowId"
      [salesOrderIdD365]="salesOrderId"
      [smallLoader]="showSmallLoader"
      [summaryPage]="false">
    </jni-workflow-line-items>
  </div>
</p-dialog>

<jni-add-workflow-updates
  *ngIf="workflowId && workflowId !== 0"
  #workflowupdatesidebar
  [(display)]="displaySidebarForNotes"
  [projectWorkflowId]="workflowId"
  [isWorkflowOwners]="true"
  (closeSidebar)="closeSideBarForOrderNotes()">
</jni-add-workflow-updates>

<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<jni-confirm-dialog
  [dialogMessage]="archiveMessage"
  dialogHeading="Are you sure?"
  *ngIf="archiveAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmArchive($event)">
</jni-confirm-dialog>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerIdD365"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>

<jni-modal-stacker
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<p-dialog
  appendTo="body"
  [modal]="true"
  [(visible)]="showConfirmDialogForMultipleArchive">
  <ng-template pTemplate="header">
    <div class="inline-flex items-center justify-center gap-2">
      <span
        class="font-bold whitespace-nowrap"
        style="font-size: 21px; font-weight: bold"
        >Bulk Archive Confirmation
      </span>
      <i class="pi pi-exclamation-triangle"></i>
    </div>
  </ng-template>

  <div class="p-fluid p-dir-col p-p-3">
    <div class="p-field p-mb-2 field-wrap">
      <h3
        class="text-bold matchMode form-group has-float-label mb-1"
        style="font-size: 15px">
        You want to mark selected projects as Archived?
      </h3>
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <button
        class="btn btn-secondary me-2"
        type="button"
        (click)="cancelDialog()">
        No
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="confirmDialogToArchiveMultipleProjects()">
        Yes
      </button>
    </div>
  </div>
</p-dialog>
